// Tanggal simulasi uji coba (backend/utils/jamSimulasi.js) di sisi browser.
//
// Server menggeser jamnya N hari; layar admin harus ikut, karena "hari ini"
// di klien (tanggalWIB, default filter bulan, batas date input…) dibaca dari
// jam perangkat. `Date` dibungkus dengan offset yang SAMA. Offset disimpan di
// localStorage dan dipasang saat modul ini dimuat — diimpor PALING AWAL di
// index.js, sebelum komponen apa pun membaca jam. Kalau server melaporkan
// offset lain (diubah Super admin), halaman dimuat ulang supaya semua layar
// mulai dari tanggal yang sama.
const KUNCI = 'ft_sim_hari';
const SEHARI = 86400000;
const RealDate = window.Date;

function baca() {
  try {
    return Math.max(0, parseInt(localStorage.getItem(KUNCI) || '0', 10) || 0);
  } catch {
    return 0;
  }
}

const offsetHari = baca();

if (offsetHari > 0) {
  function DateSim(...a) {
    const sekarang = RealDate.now() + offsetHari * SEHARI;
    if (!new.target) return new RealDate(sekarang).toString();
    return a.length ? new RealDate(...a) : new RealDate(sekarang);
  }
  DateSim.prototype = RealDate.prototype;
  DateSim.now = () => RealDate.now() + offsetHari * SEHARI;
  DateSim.UTC = RealDate.UTC;
  DateSim.parse = RealDate.parse;
  Object.defineProperty(DateSim, 'name', { value: 'Date' });
  window.Date = DateSim;
}

export const offsetSimulasi = () => offsetHari;

/** Samakan dengan server; true = halaman perlu dimuat ulang. */
export function samakanSimulasi(hariServer) {
  const h = Math.max(0, Number(hariServer) || 0);
  if (h === offsetHari) return false;
  try {
    if (h > 0) localStorage.setItem(KUNCI, String(h));
    else localStorage.removeItem(KUNCI);
  } catch {
    return false; // tanpa storage tidak bisa ikut — jangan memuat ulang terus-menerus
  }
  return true;
}
